import { render, staticRenderFns } from "./DueDiligenceCover.vue?vue&type=template&id=3079d6c0&"
import script from "./DueDiligenceCover.vue?vue&type=script&lang=js&"
export * from "./DueDiligenceCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3079d6c0')) {
      api.createRecord('3079d6c0', component.options)
    } else {
      api.reload('3079d6c0', component.options)
    }
    module.hot.accept("./DueDiligenceCover.vue?vue&type=template&id=3079d6c0&", function () {
      api.rerender('3079d6c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/forms/due-diligence/DueDiligenceCover.vue"
export default component.exports